import { render } from "./TheExtension.vue?vue&type=template&id=9785bf40"
import script from "./TheExtension.vue?vue&type=script&lang=js"
export * from "./TheExtension.vue?vue&type=script&lang=js"
script.render = render

export default script